import React from 'react';
import classes from './downloadButton.module.css';
import { useTranslation } from 'react-i18next';
import { isIOS, isSafari } from 'react-device-detect';

const DownloadButton = () => {
  const { t } = useTranslation();

  return isIOS || isSafari ? (
    <div className={classes.links}>
      <a href="https://itunes.apple.com/app/id1456056270">
        {t('GET THE DREAMS BUILDER APP')}
      </a>
    </div>
  ) : (
    <div className={classes.links}>
      <a href="https://play.google.com/store/apps/details?id=com.ditsay.android">
        {t('GET THE DREAMS BUILDER APP')}
      </a>
    </div>
  );
};

export default DownloadButton;
